import { useMutation } from '@tanstack/react-query';
import { useApi } from './useApi';

interface TokenResponse {
  token: string;
}

export function useGenerateCostCalculatorToken() {
  const { makeApiRequest } = useApi();
  return useMutation({
    mutationFn: (): Promise<TokenResponse> =>
      makeApiRequest('/tokens', 'POST', { type: 'cost_calculator', expires_minutes: 60 }),
  });
}
